import { crossplay } from "./crossplay.mjs";
import { tutorial } from "./tutorial.mjs";
const game = {
  /** Track common game crossplay events, i.e., events related to web/native client transitions. */
  crossplay,
  /** Track common game tutorial events. */
  tutorial
};
export {
  game
};
